module.exports = __webpack_public_path__ + "static/media/ceremonie.76ad345e.jpg";